import { render } from "./project-details.vue?vue&type=template&id=19445503"
import script from "./project-details.vue?vue&type=script&lang=js"
export * from "./project-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__